import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  width: 100%;
  max-width: 433px;
  max-height: 90%;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Button = styled.button`
  border-radius: 12px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  height: 24px;
  display: flex;
  align-items: center;
  margin-left: 8px;
  border: none;
  background: #d0dae3;
  font-size: 14px;
  /* identical to box height */
  text-align: center;

  /* beam texts/logo text */
  color: #3c546b;
`;

export const Block = styled.div`
  background: ${beam.color.pureWhite};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 24px;
  width: 433px;
  z-index: 995;
  left: 80px;
`;

export const Title = styled.div`
  color: ${beam.font.primary};
  font-size: 24px;
  margin-bottom: 16px;
`;

export const Icon = styled.div`
  margin-right: 8px;
`;

export const Back = styled.img`
  cursor: pointer;
`;

export const SpacingDivider = styled.div`
  width: 16px;
`;
